import { useEffect, useState } from 'react';
import { FAB, ArrowUp } from '@desquared/wave-components-library';
import styles from './ScrollToTop.module.css';
import cn from 'classnames';

const DEFAULT_SCROLL_THRESHOLD = 500;

export default function ScrollToTop({ threshold = DEFAULT_SCROLL_THRESHOLD }) {
  const [isVisible, setIsVisible] = useState(false);

  function onClickBackToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleScroll() {
    const distanceFromTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    if (distanceFromTop > threshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    //eslint-disable-next-line
  }, []);

  return (
    <FAB
      onClick={onClickBackToTop}
      className={cn(styles.container, { [styles.visible]: isVisible, [styles.hidden]: !isVisible })}
      variant={'primary'}
      renderIcon={() => <ArrowUp />}
    />
  );
}
